module.exports = __webpack_public_path__ + "static/media/VestasSans-Extrabold.15507d3b.eot";